import { coreAgent } from "../../app/api/agent";
import { PresentingProblemDto } from "./dtos/PresntingProblemDto";

export const getPresentingProblemsRequest = () =>
  coreAgent.getRequest<PresentingProblemDto[]>(`presentingProblems`);
